import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Sparkles } from 'lucide-react';
const tomos = [{
  number: 'TOMO 1',
  price: '$8.000',
  title: 'Fundamentos Energéticos',
  color: 'from-red-500/20 to-orange-500/20',
  borderColor: 'border-red-500/30',
  topics: ['Energía y Vibración', 'Sistema de Chakras', 'Anatomía del Aura', 'Frecuencia Personal']
}, {
  number: 'TOMO 2',
  price: '$8.000',
  title: 'Introducción a la Mesa Cuántica',
  color: 'from-orange-500/20 to-yellow-500/20',
  borderColor: 'border-orange-500/30',
  topics: ['Radiestesia Básica', 'Uso del Péndulo', 'Gráficos Energéticos', 'Preparación Espiritual']
}, {
  number: 'TOMO 3',
  price: '$9.000',
  title: 'Protocolos de Sanación',
  color: 'from-yellow-500/20 to-green-500/20',
  borderColor: 'border-green-500/30',
  topics: ['Liberación de Ansiedad', 'Sanación de Autoestima', 'Bloqueos del Dinero', 'Armonización de Relaciones']
}, {
  number: 'TOMO 4',
  price: '$8.000',
  title: 'Sesiones Paso a Paso',
  color: 'from-green-500/20 to-blue-500/20',
  borderColor: 'border-blue-500/30',
  topics: ['Estructura de Sesiones', 'Lectura Energética', 'Armonización Profunda', 'Protocolos Online']
}, {
  number: 'TOMO 5',
  price: '$8.000',
  title: 'Abundancia y Manifestación',
  color: 'from-blue-500/20 to-indigo-500/20',
  borderColor: 'border-indigo-500/30',
  topics: ['Leyes de Prosperidad', 'Frecuencia del Dinero', 'Técnicas de Manifestación', 'Reprogramación Mental']
}, {
  number: 'TOMO 6',
  price: '$8.990',
  title: 'Profesionalización',
  color: 'from-indigo-500/20 to-purple-500/20',
  borderColor: 'border-purple-500/30',
  topics: ['Venta de Sesiones', 'Marca Personal Espiritual', 'Instagram Holístico', 'Atracción de Clientes']
}];
export function Tomos() {
  return <section className="py-16 relative z-10 bg-[#0a0517]" data-id="element-102">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#7c3aed]/50 to-transparent" data-id="element-103" />

      <div className="container mx-auto px-4" data-id="element-104">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-bold mb-5" data-id="element-106">
            El Sistema de <span className="text-gold-gradient" data-id="element-107">6 Tomos</span>
          </h2>

          {/* Highlighted price banner */}
          <motion.div className="inline-flex flex-col items-center gap-2 px-6 py-4 rounded-2xl bg-gradient-to-r from-[#fbbf24]/15 via-[#f59e0b]/20 to-[#fbbf24]/15 border-2 border-[#fbbf24]/50 shadow-[0_0_40px_rgba(251,191,36,0.25)]" animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-108">
            <div className="flex items-center gap-2 text-white/60 text-sm" data-id="element-109">
              <Sparkles className="w-4 h-4 text-[#fbbf24]" data-id="element-110" />
              <span className="uppercase tracking-wider" data-id="element-111">
                Valor real <span className="line-through" data-id="element-112">$49.990</span>
              </span>
              <Sparkles className="w-4 h-4 text-[#fbbf24]" data-id="element-113" />
            </div>
            <p className="font-cinzel font-bold text-xl md:text-2xl" data-id="element-114">
              <span className="text-white" data-id="element-115">Hoy te lo llevas por </span>
              <span className="text-gold-gradient text-2xl md:text-3xl" data-id="element-116">
                $19.990
              </span>
            </p>
          </motion.div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-117">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className={`relative rounded-2xl overflow-hidden border ${tomo.borderColor} bg-gradient-to-b ${tomo.color} backdrop-blur-sm group`} data-id="element-118">
              <div className="absolute inset-0 bg-[#130b29]/80 z-0" data-id="element-119" />

              <div className="relative z-10 p-6 h-full flex flex-col" data-id="element-120">
                <div className="flex justify-between items-center mb-4" data-id="element-121">
                  <span className="text-sm font-cinzel font-bold tracking-widest text-[#fbbf24] uppercase" data-id="element-122">
                    {tomo.number}
                  </span>
                  <span className="text-sm font-bold text-white/90 px-3 py-1 rounded-full bg-[#fbbf24]/10 border border-[#fbbf24]/30" data-id="element-123">
                    {tomo.price}
                  </span>
                </div>

                <h3 className="text-xl font-cinzel font-bold mb-5 text-white" data-id="element-124">
                  {tomo.title}
                </h3>

                <ul className="space-y-2.5 mt-auto" data-id="element-125">
                  {tomo.topics.map((topic, i) => <li key={i} className="flex items-start gap-3 text-white/70" data-id="element-126">
                      <CheckCircle2 className="w-4 h-4 text-[#a855f7] shrink-0 mt-0.5" data-id="element-127" />
                      <span className="text-sm" data-id="element-128">{topic}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}